<template>
  <div class="config-central-page">
    <div class="dashboard-header mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="dashboard-header-titulo-row">
          <h2 class="dashboard-title">
            <feather-icon
              icon="SettingsIcon"
              size="32"
              class="titulo-icon-left"
            />
            <span class="titulo-texto">Configuração da Central de Atendimento</span>
            <router-link
              :to="{ name: 'dashboard-main' }"
              class="dashboard-header-home"
              title="Ir para o início"
            >
              <feather-icon
                icon="HomeIcon"
                size="16"
                class="dashboard-header-home-icon"
              />
            </router-link>
          </h2>
        </div>
        <p class="text-muted mb-0 w-100 dashboard-header-subtitle">
          Defina o horário em que haverá pelo menos um atendente disponível para conversar com o contato
        </p>
      </div>
    </div>

    <b-card
      v-if="facebookAccountsLista.length > 1"
      class="mb-4 card-selecao-loja"
    >
      <div class="d-flex flex-wrap align-items-center">
        <feather-icon
          icon="StoreIcon"
          size="18"
          class="mr-2 text-primary"
        />
        <label class="mb-0 mr-3 font-weight-bold">Selecionar Loja:</label>
        <b-form-select
          v-model="chatSelecionado"
          :options="facebookAccountsLista.map(conta => ({
            value: conta.chat_token,
            text: conta.name
          }))"
          class="select-loja"
          @change="carregarHorario"
        />
      </div>
    </b-card>

    <b-card v-if="!chatSelecionado" class="mb-4">
      <p class="text-muted mb-0">
        Selecione uma loja para configurar o horário de funcionamento.
      </p>
    </b-card>

    <template v-else>
      <b-card class="mb-4">
        <p class="text-muted small mb-4">
          Para cada dia da semana, adicione um ou mais intervalos (abertura e fechamento). Deixe sem intervalos para o dia ficar fora do horário de atendimento.
        </p>
        <div
          v-for="dia in 7"
          :key="dia - 1"
          class="dia-row mb-4"
        >
          <div class="dia-titulo mb-2">
            <strong>{{ nomesDias[dia - 1] }}</strong>
          </div>
          <div class="intervalos-do-dia">
            <div
              v-for="(intervalo, idx) in horarioPorDia[dia - 1]"
              :key="`${dia}-${idx}`"
              class="intervalo-row d-flex align-items-center flex-wrap mb-2"
            >
              <b-form-input
                v-model="intervalo.abre"
                type="time"
                class="intervalo-input mr-2"
                placeholder="Abre"
              />
              <span class="mr-2">até</span>
              <b-form-input
                v-model="intervalo.fecha"
                type="time"
                class="intervalo-input mr-2"
                placeholder="Fecha"
              />
              <b-button
                variant="outline-danger"
                size="sm"
                class="btn-remover"
                @click="removerIntervalo(dia - 1, idx)"
              >
                <feather-icon icon="Trash2Icon" size="14" />
              </b-button>
            </div>
            <b-button
              variant="outline-primary"
              size="sm"
              @click="adicionarIntervalo(dia - 1)"
            >
              <feather-icon icon="PlusIcon" size="14" class="mr-1" />
              Adicionar intervalo
            </b-button>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3 pt-3 border-top">
          <b-button
            variant="primary"
            :disabled="salvando"
            @click="salvar"
          >
            <b-spinner v-if="salvando" small type="grow" class="mr-1" />
            Salvar horário de funcionamento
          </b-button>
        </div>
      </b-card>
    </template>
  </div>
</template>

<script>
import {
  buscaChatsTeste,
  getHorarioFuncionamento,
  putHorarioFuncionamento,
} from '../../functions/basics/chat'

const NOMES_DIAS = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']

function horarioVazio() {
  return Array.from({ length: 7 }, () => [])
}

export default {
  name: 'ConfiguracaoCentralAtendimento',
  data() {
    return {
      facebookAccountsLista: [],
      chatSelecionado: null,
      horarioPorDia: horarioVazio(),
      salvando: false,
      carregando: false,
      nomesDias: NOMES_DIAS,
    }
  },
  watch: {
    '$route.query': {
      handler(query) {
        if (query && query.uuid && this.facebookAccountsLista.some(c => c.chat_token === query.uuid)) {
          this.chatSelecionado = query.uuid
          this.carregarHorario()
        }
      },
      immediate: false,
    },
  },
  mounted() {
    this.carregarLojas().then(() => {
      const uuid = this.$route.query?.uuid || this.$route.params?.uuid
      if (uuid && this.facebookAccountsLista.some(c => c.chat_token === uuid)) {
        this.chatSelecionado = uuid
      }
      this.carregarHorario()
    })
  },
  methods: {
    adicionarIntervalo(dia) {
      if (!this.horarioPorDia[dia]) this.horarioPorDia[dia] = []
      this.horarioPorDia[dia].push({ abre: '08:00', fecha: '12:00' })
    },
    removerIntervalo(dia, idx) {
      if (this.horarioPorDia[dia]) {
        this.horarioPorDia[dia].splice(idx, 1)
      }
    },
    async carregarLojas() {
      const contas = await buscaChatsTeste()
      this.facebookAccountsLista = contas.chats || []
      if ((contas.chats || []).length === 1) {
        this.chatSelecionado = contas.chats[0].chat_token
      } else if ((contas.chats || []).length > 1 && !this.chatSelecionado) {
        this.chatSelecionado = (contas.chats[0] && contas.chats[0].chat_token) || null
      }
    },
    async carregarHorario() {
      if (!this.chatSelecionado) return
      this.carregando = true
      try {
        const res = await getHorarioFuncionamento(this.chatSelecionado)
        const list = res.horarioFuncionamento || (Array.isArray(res) ? res : [])
        const porDia = horarioVazio()
        list.forEach(({ dia, abre, fecha }) => {
          const d = Number(dia)
          if (d >= 0 && d <= 6) {
            porDia[d].push({ abre: abre || '08:00', fecha: fecha || '12:00' })
          }
        })
        this.horarioPorDia = porDia
      } catch (err) {
        console.error('Erro ao carregar horário:', err)
        this.$bvToast.toast(err.message || 'Erro ao carregar horário de funcionamento.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
        this.horarioPorDia = horarioVazio()
      } finally {
        this.carregando = false
      }
    },
    async salvar() {
      if (!this.chatSelecionado) return
      const horarioFuncionamento = []
      for (let dia = 0; dia < 7; dia++) {
        const intervalos = this.horarioPorDia[dia] || []
        intervalos.forEach(({ abre, fecha }) => {
          horarioFuncionamento.push({
            dia,
            abre: abre || '08:00',
            fecha: fecha || '12:00',
          })
        })
      }
      this.salvando = true
      try {
        await putHorarioFuncionamento(this.chatSelecionado, horarioFuncionamento)
        this.$bvToast.toast('Horário de funcionamento salvo com sucesso.', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
      } catch (err) {
        console.error('Erro ao salvar horário:', err)
        this.$bvToast.toast(err.message || 'Erro ao salvar horário de funcionamento.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>

<style>
body:has(.config-central-page) .content-area-wrapper {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-width: 100% !important;
  width: 100% !important;
}
body:has(.config-central-page) .app-content.content {
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100% !important;
}
body:has(.config-central-page) .content-wrapper,
body:has(.config-central-page) .content-body {
  padding: 0 !important;
  margin: 0 !important;
  max-width: 100% !important;
}
body:has(.config-central-page) .content-right {
  width: 100% !important;
  max-width: 100% !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
}
</style>

<style scoped>
.config-central-page {
  padding: 1rem;
  min-height: 100vh;
  max-width: 100%;
  overflow-x: hidden;
}

.dashboard-header {
  background: linear-gradient(135deg, #9A3092 0%, #c44ab8 100%);
  padding: 1.25rem 1.5rem;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(154, 48, 146, 0.25);
}

.dashboard-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.dashboard-title .titulo-icon-left {
  flex-shrink: 0;
}

.dashboard-title .titulo-texto {
  line-height: 1;
}

.dashboard-header-home {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.95);
  padding: 0.2rem;
  border-radius: 8px;
  transition: background 0.2s, color 0.2s;
  flex-shrink: 0;
}

.dashboard-header-home >>> svg {
  display: block;
  width: 16px;
  height: 16px;
}

.dashboard-header-home:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.dashboard-header .text-muted {
  color: rgba(255, 255, 255, 0.9) !important;
}

.dashboard-header-subtitle {
  margin-top: 0.15rem;
}

.dashboard-header-titulo-row {
  margin-bottom: 0.15rem;
}

.card-selecao-loja .select-loja {
  max-width: 300px;
  min-width: 0;
}

.dia-row {
  padding-bottom: 1rem;
  border-bottom: 1px solid #ebe9f1;
}

.dia-row:last-of-type {
  border-bottom: none;
}

.dia-titulo {
  color: #5e5873;
}

.intervalo-input {
  max-width: 120px;
}

.btn-remover {
  margin-left: 0.25rem;
}
</style>
